<template>
    <div class="flex-column list bi m01 r4 p10 pointer" :style="boxStyle" @click="onClick">
        <div class="f16w">{{ config.Title }}</div>
        <div class="number f30w ">
            {{ value }}<span class="f12" style="color: #fff" v-if="config.Unit">{{ config.Unit }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: Number,
        config: Object,
        index: Number
    },
    computed: {
        boxStyle() {
            return {
                backgroundColor: this.config.backgroundColor
            }
        }
    },
    methods: {
        onClick() {
            this.$emit('event', { config: this.config, value: this.value })
        }
    }
}
</script>
   